<template>
  <div>
    <div class="button-area">
      
      <Button @click="back()" class="button-right">返回</Button>
    </div>
    <div class="form-area">
      <Form
        style="width: 1100px"
        :model="model"
        :label-width="110"
        label-position="left"
        inline
      >
        <FormItem>
            <h3 style="width: 320px">产品信息</h3>
        </FormItem>
        <br />
        
        <FormItem readonly label="产品图片">
          <div v-if="model.productPic">
            <div v-for="(item, index) in model.productPic" :key="index">
              <img style="width: 200px; height: 160px" :src="item.url" alt="" />
            </div>
          </div>
          <div v-else>
            <img
              style="width: 200px; height: 160px"
              src="../../../../assets/noPic.jpg"
              alt=""
            />
          </div>
        </FormItem>
        <br />
        <FormItem label="产品名称">
          <Input
            readonly
            v-model="model.productName"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        <FormItem label="发布日期">
          <Input
            readonly
            v-model="model.releaseTime"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        <br />
        <FormItem label="产品规格">
          <Input
            readonly
            v-model="model.productSpecifications"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        
        <FormItem label="产品数量">
          <Input
            readonly
            v-model="model.productNum"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        <br />
        <FormItem label="产品单价">
          <Input
            readonly
            v-model="model.productPrice"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        
        <FormItem label="供应说明">
          <Input
            readonly
            v-model="model.productSpec"
            style="width: 500px"
            :autosize="{minRows: 5}"
            type="textarea"
          ></Input>
        </FormItem>
        <br />
        <FormItem>
            <h3 style="width: 320px">企业信息</h3>
        </FormItem>
        <br />
        <FormItem label="企业名称">
          <Input
            readonly
            v-model="model.companyName"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        <FormItem label="联系人">
          <Input
            readonly
            v-model="model.concatName"
            style="width: 320px"
            type="text"
          ></Input> </FormItem
        ><br />
        <FormItem label="联系方式">
          <Input
            readonly
            v-model="model.concatPhone"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        <FormItem label="所属区域">
          <Input
            readonly
            :value="model.city + model.area + model.town"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem>
        <br />
        <!-- <FormItem label="联系地址">
          <Input
            readonly
            v-model="model.address"
            style="width: 320px"
            type="text"
          ></Input>
        </FormItem> -->
      </Form>
    </div>
    <div
      v-show="model.status !== 1"
      @click="changes"
      style="
        border: 1px solid #ccc;
        text-align: center;
        width: 150px;
        height: 50px;
        line-height: 50px;
        margin: 0 auto;
        cursor: pointer;
      "
    >
      下架
    </div>
  </div>
</template>

<script>
import util from "@/libs/util.js";
import moment from 'moment'

export default {
  name: "tqtEnterpriseCooperationForm",
  data() {
    return {
      //ID
      id: null,
      saveLoading: false,
      //表单参数
      model: {
        id: null,
        companyCode: null,
        userId: null,
        productName: null,
        productPic: null,
        releaseTime: null,
        endTime: null,
        category: null,
        productSpecifications: null,
        productNum: null,
        productPrice: null,
        productSpec: null,
        status: null,
        type: null,
        updateTime: null,
        updateUserId: null,
        areaCode: null,
      },
    };
  },
  mounted() {
    console.log(this.$route.query.id);
    if (
      typeof this.$route.query.id !== "undefined" &&
      this.$route.query.id !== null &&
      this.$route.query.id !== ""
    ) {
      this.id = this.$route.query.id;
      //ID存在渲染表单
      this.initForm();
    }
  },
  methods: {
    //下架
    changes() {
      let _this = this;
      this.$Modal.confirm({
        title: "确定下架？",
        onOk() {
          util.http
            .get(
              "/api/1.0/tqt_enterprise_cooperation/offProducts/" + _this.id,
              {
                id: _this.id,
              }
            )
            .then((response) => {
              if (response.status === 200) {
                _this.$Notice.success({
                  title: "下架成功",
                });
                _this.model.status = 1;
              } else {
                _this.$Notice.error({
                  title: "下架失败",
                });
              }
            });
        },
      });
    },
    //保存
    save() {
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },

    create() {
      let _this = this;
      _this.saveLoading = true;
      util.ajax
        .post("/api/tqtEnterpriseCooperations", this.model, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          _this.$Notice.success({
            title: "保存成功!",
          });
          _this.back();
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "保存失败!",
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },

    update() {
      let _this = this;
      _this.saveLoading = true;
      util.ajax
        .put("/api/tqtEnterpriseCooperations", this.model, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          _this.$Notice.success({
            title: "更新成功!",
          });
          _this.back();
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "更新失败!",
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },

    //渲染表单
    initForm() {
      let _this = this;
      util.http
        .get(
          "/api/1.0/tqt_enterprise_cooperation/tqtEnterpriseCooperations/" +
            this.id,
          {
            params: {},
          }
        )
        .then(function (response) {
          let tem = response.data;
          (_this.model.id = tem.id),
            (_this.model.companyCode = tem.companyCode),
            (_this.model.userId = tem.userId),
            (_this.model.productName = tem.productName),
            (_this.model.productPic = tem.productPic),
            (_this.model.releaseTime = moment(tem.releaseTime).format('YYYY-MM-DD')),
            // (_this.model.releaseTime = _this.formatTime(_this.model.releaseTime)),
            (_this.model.endTime = moment(tem.endTime).format('YYYY-MM-DD')),
            (_this.model.category = tem.category),
            (_this.model.productSpecifications = tem.productSpecifications),
            (_this.model.productNum = tem.productNum),
            (_this.model.productPrice = tem.productPrice),
            (_this.model.productSpec = tem.productSpec),
            (_this.model.status = tem.status),
            (_this.model.type = tem.type),
            (_this.model.updateTime = tem.updateTime),
            (_this.model.updateUserId = tem.updateUserId),
            (_this.model.areaCode = tem.areaCode);
          _this.model.address = tem.address;
          _this.model.city = tem.city;
          _this.model.town = tem.town;
          _this.model.area = tem.area;
          _this.model.areaCode = tem.areaCode;
          _this.model.city = tem.city;
          _this.model.companyName = tem.companyName;
          _this.model.concatName = tem.concatName;
          _this.model.concatPhone = tem.concatPhone;
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "获取表单失败!",
          });
          console.log(error);
        });
    },

    //返回,需要自定义配置路由
    back() {
      this.$store.commit('app/closePage', {
          vm: this,
          route:{
            name:'tqt_enterprise_cooperation',
            query:{
              tabName:this.model.type==1?'name2':'name1'
            }
          }
      })
    },
  },
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}
.ivu-form-item{
    margin-right:60px
}
</style>
